import { IntegrationBase } from './base';

export class DefaultIntegration extends IntegrationBase {}
